import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { getBackgroundImageCss } from "../../js/util";

function SubBanner(props) {
  const store = useSelector((state) => state);
  const [subMenuTitle01, setSubMenuTitle01] = useState("");
  const [subMenuTitle02, setSubMenuTitle02] = useState("");
  const backgroundImageCss = getBackgroundImageCss(props.id);
  useEffect(
    () => {
      setSubMenuTitle01(store.reducerPage.sub01);
      setSubMenuTitle02(store.reducerPage.sub02);
    },
    // eslint-disable-next-line
    [props]
  );

  return (
    <section className={`page-title ${backgroundImageCss}`}>
      <div className="container">
        <div className="row">
          <div className="col-md-12">
            <div className="block text-center">
              <h1 className="text-capitalize mb-5 text-lg">{subMenuTitle02}</h1>

              <ul className="list-inline breadcumb-nav">
                <li className="list-inline-item">
                  <Link to="/" className="text-white">
                    Home
                  </Link>
                </li>
                <li className="list-inline-item">
                  <span className="text-white">/</span>
                </li>
                <li className="list-inline-item text-white">
                  {subMenuTitle01}
                </li>
                <li className="list-inline-item">
                  <span className="text-white">/</span>
                </li>
                <li className="list-inline-item text-white">
                  {subMenuTitle02}
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default SubBanner;
